import React from "react";
import PropTypes from "prop-types";
import { Button, Text, makeStyles, Spinner } from "@fluentui/react-components";
import { ArrowCircleRight24Regular } from "@fluentui/react-icons";
import aiscribeLogo from "../assets/aiscribe_logo.png";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh", 
    textAlign: "center",
    gap: "16px", 
    padding: "20px",
  },
  logoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",

  },
  logo: {
    width: "200px",
    height: "200px",
  },
  appName: {
    fontSize: "28px",
    fontWeight: "600",
    color: "#1a54a3", 
  },
  mainTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#0f4bad",
  },
  subtitle: {
    fontSize: "14px",
    color: "#605e5c", 
    marginTop: "-12px",
  },
  loginButton: {
    minWidth: "260px",
    height: "44px",
    borderRadius: "9999px", 
  },
  errorText: {
    color: "#d13438", 
    marginTop: "10px",
  }
});

/**
 * COMPONENT DEFINITION
 * @param {function} onLogin - Function triggered when button is clicked
 * @param {boolean} isLoading - State indicating if auth is in progress
 * @param {} error - Error message to display (if any)
 */
const LoginPage = ({ onLogin, isLoading, error }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      {/* Logo and App Name */}
      <div className={styles.logoContainer}>
        <img src={aiscribeLogo} alt="AIScribe logo" className={styles.logo} />
      </div>

      {/* Titles */}
      <Text as="h2" className={styles.mainTitle}>
        Medical Writing Smart Assist
      </Text>
      <Text as="p" className={styles.subtitle}>
        Powered by Google GenAI
      </Text>

      {/* Login Button */}
      <Button
        appearance="primary"
        size="large"
        onClick={onLogin}
        className={styles.loginButton}
        icon={isLoading ? <Spinner size="tiny" /> : <ArrowCircleRight24Regular />}
        iconPosition="before"
        disabled={isLoading}
      >
        {isLoading ? "Signing In..." : "Using Roche Credential"}
      </Button>

    </div>
  );
};

LoginPage.propTypes = {
  onLogin: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
};

export default LoginPage;